module.exports = __webpack_public_path__ + "img/ercode.bcb7911f.jpg";